<script setup lang="ts">
import { onMounted, computed } from 'vue';
import { useHealthStore } from '@/stores/health';
import Lucide from '@/components/Base/Lucide';

const props = defineProps<{ size?: string }>();
const health = useHealthStore();

onMounted(() => {
  if (!health.report) {
    health.fetchReport();
  }
});

const color = computed(() => {
  switch (health.overallStatus) {
    case 'Healthy':
      return 'text-green-500';
    case 'Degraded':
      return 'text-amber-500';
    case 'Unhealthy':
      return 'text-red-500';
    default:
      return 'text-slate-500';
  }
});
</script>

<template>
  <Lucide icon="Activity" :class="[props.size || 'w-5 h-5', color]" />
</template>
